var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"students"},[_c('div',{staticClass:"students__content"},[_c('div',{staticClass:"students__description"},[_c('intro',{attrs:{"title":_vm.title,"description":_vm.description,"backLinkSrc":'/'}})],1),_vm._v(" "),_vm._l((_vm.studentList),function(student){return _c('student-item',{key:'student'+student.id,attrs:{"student":student}})})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca0161b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Students.vue
// module id = null
// module chunks = 